import dynamic from 'next/dynamic'
import { StudentDetailsModalProps } from '@components/trial-class/join/student-details-modal'
const StudentDetailsModal = dynamic(() =>
  import('@components/trial-class/join/student-details-modal')
)

const StudentDetailsModalDynamic = (props: StudentDetailsModalProps) => (
  <>{props.isOpen && <StudentDetailsModal {...props} />}</>
)

export default StudentDetailsModalDynamic
